require('./lbLoadingPlaceholder.scss');

const $inject = [];

const lbLoadingPlaceholderItem = {
  template: require('./lbLoadingPlaceholderItem.html'),
  controller: 'lbLoadingPlaceholderItemCtrl',
  controllerAs: 'vm',
  bindings: {
    total: '<',
    isHeading: '<',
    width: '<',
  },
};

lbLoadingPlaceholderItem.$inject = $inject;

export default lbLoadingPlaceholderItem;



// WEBPACK FOOTER //
// ./src/components/lbLoadingPlaceholder/lbLoadingPlaceholderItem.js